var AUTH_FLOW_OPTIONS = /*#__PURE__*/ function(AUTH_FLOW_OPTIONS) {
    AUTH_FLOW_OPTIONS["APPLE_SSO"] = "sso-apple";
    AUTH_FLOW_OPTIONS["GOOGLE_SSO"] = "sso-google";
    AUTH_FLOW_OPTIONS["EMAIL_PASSWORD"] = "general";
    AUTH_FLOW_OPTIONS["EMAIL_PASSWORD_SIGNUP"] = "signup";
    AUTH_FLOW_OPTIONS["SIGN_IN_WITH_CODE"] = "sign-in-with-code";
    return AUTH_FLOW_OPTIONS;
}({});
var AUTH_PROVIDER_NAMES = /*#__PURE__*/ function(AUTH_PROVIDER_NAMES) {
    AUTH_PROVIDER_NAMES["GOOGLE"] = "Google";
    AUTH_PROVIDER_NAMES["APPLE"] = "SignInWithApple";
    return AUTH_PROVIDER_NAMES;
}({});

export { AUTH_FLOW_OPTIONS, AUTH_PROVIDER_NAMES };
//# sourceMappingURL=auth.types.js.map
